import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Link } from 'site-modules/shared/components/link/link';
import './first-looks.scss';

function renderSegment(content) {
  const { 'vehicle-title': vehicleTitle, 'vehicle-url': vehicleUrl } = content.getAllMetadata();
  return (
    <Col xs={12} md={3} lg={12} className="first-looks-item" key={vehicleTitle}>
      <Link to={vehicleUrl} className="fw-bold d-block py-1">
        {vehicleTitle}
      </Link>
      <hr className="w-100 d-md-none d-lg-block m-0" />
    </Col>
  );
}

export function FirstLooks({ content = {}, className = '' }) {
  const contentEntries = content.children();
  const title = content.title;

  return (
    <div className={classnames('first-looks', className)}>
      <h2 className="heading-3 pb-1">{title}</h2>
      <Row className="content-list px-lg-1 pb-1_5 pb-md-0 pb-lg-1_5">
        {contentEntries && contentEntries.map(item => renderSegment(item))}
      </Row>
    </div>
  );
}

FirstLooks.propTypes = {
  content: PropTypes.shape({}),
  className: PropTypes.string,
};
